import React, { createContext, useState, useContext, useEffect } from 'react';
import elTranslations from './el';

// Default English translations - could be moved to a separate file like el.js
const enTranslations = {};

// Create the context
const LanguageContext = createContext();

// Language provider component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en'); // Default to English
  const [translations, setTranslations] = useState(enTranslations);

  // Effect to load translations when language changes
  useEffect(() => {
    if (language === 'el') {
      setTranslations(elTranslations);
    } else {
      setTranslations(enTranslations);
    }
  }, [language]);

  // Function to change the language
  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('preferredLanguage', lang); // Save preference to localStorage
  };

  // Function to get a translated string
  const t = (key, params = {}) => {
    let translated = translations[key] || key;
    
    // Replace any parameters in the string (like {year})
    Object.keys(params).forEach(param => {
      translated = translated.replace(`{${param}}`, params[param]);
    });
    
    return translated;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use the language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
